// Fruity Slider JS - Loop + GSAP Animations Restored
(function () {
  for (const key in window) {
    if (key.startsWith("fruity_slider_data_")) initFruitySlider(window[key]);
  }

  function initFruitySlider(data) {
    const sectionId = data.sectionId;
    const root = document.getElementById("fruity-slider-" + sectionId);
    if (!root) return;

    const container = document.getElementById("section-container-" + sectionId);
    const prevBtn = document.getElementById("prevButton-" + sectionId);
    const nextBtn = document.getElementById("nextButton-" + sectionId);
    const caneImg = document.getElementById("caneImage-" + sectionId);
    
    const titleEl = root.querySelector(".h1");

    const titles = data.titles;
    const caneImages = data.caneImages;
    const logoColors = data.logoColors;
    const waveColors = data.waveColors;
    const total = data.blockCount;

    const gsap = window.gsap;

    let currentIndex = 0;

    // Continuous Floating Animation (same as old script)
    if (gsap) {
      const floatTargets = root.querySelectorAll(".fruit-image img");
      gsap.to(floatTargets, {
        x: "random(-20,20)",
        y: "random(-20,20)",
        duration: 2,
        ease: "none",
        repeat: -1,
        yoyo: true
      });
    }

    // Init container slide transition
    container.style.transition = "transform 0.6s ease-in-out";
    updateSlide(0);

    // Next Button → LOOP MODE
    nextBtn.addEventListener("click", () => {
      currentIndex = (currentIndex + 1) % total;
      animateSlideChange("next");
    });

    // Prev Button → LOOP MODE
    prevBtn.addEventListener("click", () => {
      currentIndex = (currentIndex - 1 + total) % total;
      animateSlideChange("prev");
    });

    // --- Animation Effects ---
    function animateSlideChange(direction) {
      updateSlide(currentIndex);

      if (!gsap) return;

      // Title bounce-in
      gsap.from(titleEl, { y: "20%", opacity: 0, duration: 0.5, ease: "power2.out" });

      // Fruit drop animation (direction aware)
      gsap.from(root.querySelectorAll(".fruit-image"), {
        y: direction === "next" ? "-100vh" : "100vh",
        duration: 0.5,
        stagger: 0.05,
        ease: "power3.out"
      });

      // Logo color fade
    }

    function updateSlide(index) {
      container.style.transform = `translateX(-${index * 100}vw)`;

      titleEl.innerHTML = titles[index];
      caneImg.src = caneImages[index];
    

      root.style.setProperty("--wave-color", waveColors[index]);
    }
  }
})();
